import { request } from "@/api/request"

/** 可报课包列表 */
export function fetchCoursePackageList(payload = {}) {
  return request.post("/mgm-crm-api/course-package/query", payload).then(r => r.data)
}
